<template>
  <div ref="timelineContainer" class="timeline-container">
    <button @click="scrollLeft" class="scroll-btn left-btn" v-if="isAtStart"><i class="fas fa-angle-left"></i></button>

    <div class="timeline-content">
      <div v-for="(event, index) in events" :key="index" class="timeline-item" ref="timelineItems">
        <div class="timeline-dot"></div>
        <div class="timeline-label">
          <div class="timeline-date">{{ event.date }}</div>
          <div class="timeline-action">{{ event.status }}</div>
          <div class="timeline-action">{{ event.employee !== "" ? event.employee : "-" }}</div>
          <div class="timeline-action">
            <a :href="`https://maps.google.com/?q=${event.location.lat},${event.location.lng}`" target="_blank" v-if="event.location">View location</a>
            <span v-else> - </span>
          </div>
          <!-- <a href="" v-else></a> -->
        </div>
      </div>
    </div>
    <button @click="scrollRight" class="scroll-btn right-btn" v-if="isAtEnd"><i class="fas fa-angle-right"></i></button>
  </div>
</template>

<script>
import axios from "@/axios/axios-global";
// import Swiper from "swiper";
// import "swiper/swiper-bundle.css";
export default {
  name: "TripTimeLine",
  props: { tripDetails: Object },
  data() {
    return {
      events: [],
      isAtStart: true,
      isAtEnd: false,
      colors: {},
    };
  },
  watch: {
    tripDetails() {
      this.getTimeLine();
    },
  },
  mounted() {
    const timelineContainer = this.$refs.timelineContainer;

    // Show the last element first

    timelineContainer.scrollLeft = 0;
    //   setTimeout(() => {
    //   }, 1000);
    let isDragging = false;
    let startX;
    let scrollLeft;

    // Mouse down
    timelineContainer.addEventListener("mousedown", (e) => {
      isDragging = true;
      timelineContainer.classList.add("dragging");
      startX = e.pageX - timelineContainer.offsetLeft;
      scrollLeft = timelineContainer.scrollLeft;
      this.showScroll();
    });

    // Mouse leave
    timelineContainer.addEventListener("mouseleave", () => {
      isDragging = false;
      timelineContainer.classList.remove("dragging");
    });

    // Mouse up
    timelineContainer.addEventListener("mouseup", () => {
      isDragging = false;
      timelineContainer.classList.remove("dragging");
    });

    // Mouse move
    timelineContainer.addEventListener("mousemove", (e) => {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - timelineContainer.offsetLeft;
      const walk = (x - startX) * 2; // Adjust scrolling speed
      timelineContainer.scrollLeft = scrollLeft - walk;
      this.showScroll();
    });

    this.colors = this.$store.state.auth.themeSettings.colors;

    document.documentElement.style.setProperty("--secondary-color", this.colors.secondaryColor);
    this.getTimeLine();
    //   }
  },
  methods: {
    smoothScroll(container, direction, amount, duration) {
      const start = container.scrollLeft;
      const change = direction === "right" ? amount : -amount;
      const startTime = performance.now();

      const animateScroll = (currentTime) => {
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1); // Ensure progress doesn't exceed 1
        container.scrollLeft = start + change * progress;

        if (progress < 1) {
          requestAnimationFrame(animateScroll);
        }
      };
      requestAnimationFrame(animateScroll);
    },
    scrollLeft() {
      const container = this.$refs.timelineContainer;
      this.smoothScroll(container, "left", 400, 300);
    },
    scrollRight() {
      const container = this.$refs.timelineContainer;
      this.smoothScroll(container, "right", 400, 300); // Adjust the scroll amount as needed
      this.showScroll();
    },
    async getTimeLine() {
      const payload = {
        tripid: this.tripDetails.token,
      };
      const response = await axios.post("trip/timeline", payload);
      console.log(response.data, "events");
      this.events = response.data;
      const timelineContainer = this.$refs.timelineContainer;
      setTimeout(() => {
        timelineContainer.scrollLeft = timelineContainer.scrollWidth;
      }, 0);
    },
    showScroll() {
      const container = this.$refs.timelineContainer;
      if (container.scrollLeft <= 10) this.isAtStart = false;
      else this.isAtStart = true;
      console.log(container.scrollLeft + container.clientWidth > container.scrollWidth);
      if (container.scrollLeft + container.clientWidth > container.scrollWidth) this.isAtEnd = false;
      else this.isAtEnd = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.timeline-container {
  margin-bottom: 20px;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  position: relative;
  top: 20px;
  cursor: grab;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: auto;
  border: 1px solid #ddd;
  padding: 0 20px; /* Add extra padding on both sides */
  box-sizing: border-box;
  box-shadow: 0px 0px 10px 0px rgba(106, 7, 75, 0.2);
  border-radius: 5px;
  //  border: 1px solid #000;

  user-select: none; /* Modern browsers */
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* Internet Explorer */

  scroll-behavior: smooth;
}
::-webkit-scrollbar {
  width: 0;
}

.timeline-container::-webkit-scrollbar {
  display: none;
}

.scroll-btn {
  //  background-color: #09009b;
  background: #fa7f22;
  color: white;
  border: none;
  padding: 10px;
  cursor: pointer;
  z-index: 10;
  position: sticky;
  //  width: 50px;
  border-radius: 20px;
  opacity: 0.4;
  &:hover {
    opacity: 1;
  }
}
.left-btn {
  left: 0;
}
.right-btn {
  right: 0;
}

.timeline-container.dragging {
  cursor: grabbing;
}

/* Timeline Content */
.timeline-content {
  display: flex;
  align-items: center;
  position: relative;
  padding: 20px 0;
}

/* Timeline Item */
.timeline-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  //  margin: 0 30px;
  text-align: center;
  //  max-width: 150px;
  word-wrap: break-word;
  position: relative;
  padding: 0 10px;
}

.timeline-dot {
  width: 15px;
  height: 15px;
  //  background-color: #09009b;
  background-color: #000;
  border-radius: 50%;
  position: relative;
  z-index: 2;
}

.timeline-label {
  margin-top: 10px;
  font-size: 14px;
  color: #555;
  text-align: center;
}

.timeline-date {
  font-weight: bold;
  font-size: 12px;
  //  color: #09009b;
  color: #000;
}

.timeline-action {
  font-size: 12px;
  color: #666;
  margin-top: 5px;
  word-break: break-word;
}

/* Line Connector */
.timeline-item:after {
  content: "";
  position: absolute;
  top: 7px;
  //  left: -100%;
  width: 100%;
  height: 2px;
  background-color: #ddd;
  z-index: 1;
}

.timeline-item:first-child:before {
  display: none; /* Remove line from the first item */
}
</style>
